import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";

import { useGetSupplierFeedQuery } from "./homeApi";
import { toMarkers } from "../search/suppliersMappers";
import {
  buildSearchParams,
  quantiseCoordinates,
  searchSignature,
} from "../search/supplierFilters";

const EMPTY = [];

const useSupplierFeed = ({ coordinates, filters }) => {
  const cell = useMemo(() => quantiseCoordinates(coordinates), [coordinates]);

  const params = useMemo(
    () => buildSearchParams({ coordinates: cell, filters }),
    [cell, filters]
  );

  const signature = useMemo(() => searchSignature(params), [params]);
  const hasLocation = Boolean(cell);

  const query = useGetSupplierFeedQuery(hasLocation ? params : skipToken);
  const { currentData, isFetching, isError, refetch } = query;

  const suppliers = currentData?.suppliers || EMPTY;
  const markers = useMemo(() => toMarkers(suppliers), [suppliers]);
  const total = currentData?.total ?? suppliers.length;
  const settled = Boolean(currentData) && !isFetching;

  return {
    suppliers,
    markers,
    total,
    signature,
    hasLocation,
    isFetching,
    isSuccess: Boolean(currentData),
    isError,
    refetch: hasLocation ? refetch : () => {},
    isEmpty: hasLocation && settled && !suppliers.length,
    isResolving: hasLocation && !currentData && !isError,
    isReloading: hasLocation && isFetching && !currentData,
  };
};

export default useSupplierFeed;
